import {gsap} from "./vendor.js";

let burger, menu, icon, path, label, menuContent, loader, logo;
let menuTimeline;

class Menu {
    constructor() {
        burger = document.querySelector(".js-burger");
        menu = document.querySelector(".js-menu");

        if (burger) {
            icon = burger.querySelector("svg");
            path = burger.querySelector("path:first-of-type");
            label = burger.querySelector(".c-burger_label div");
        }

        if (menu) {
            menuContent = menu.querySelector(".c-menu_content");
            loader = menu.querySelector(".c-loader");
            logo = loader?.querySelector("mtl-logo");
        }
    }

    bindEvents() {
        burger?.addEventListener("click", this.toggle.bind(this));
    }

    toggle() {
        if (document.documentElement.classList.contains("is-menu")) {
            this.close();
        } else {
            this.open();
        }
    }

    open() {
        if (!document.documentElement.classList.contains("is-menu")) {
            /**
             * Quì è importante usare il restart() e non il play() per non avere problemi
             * quando il menu viene riaperto dopo un cambio pagina.
             */
            getMenuTimeline().restart(true, false);
            document.documentElement.classList.add("is-menu");
        }
    }

    close() {
        if (document.documentElement.classList.contains("is-menu")) {
            getMenuTimeline().reverse();
            document.documentElement.classList.remove("is-menu");
        }
    }

    setActiveItem() {
        // Mappa percorsi -> data-nav
        const navMap = [
            { match: /^\/services(\/|$)/, key: "services" },
            { match: /^\/projects(\/|$)/, key: "projects" },
            { match: /^\/learn(\/|$)/, key: "learn" },
            { match: /^\/agency\/?$/, key: "agency" },
            { match: /^\/careers\/?$/, key: "careers" },
            { match: /^\/contacts\/?$/, key: "contacts" }
        ];

        // Trova la chiave attiva
        const path = window.location.pathname;
        const activeKey = navMap.find(route => route.match.test(path))?.key;

        // Imposta/rimuove la classe "-current"
        document.querySelectorAll(".c-nav_item[data-nav]").forEach(item => {
            item.classList.toggle("-current", item.dataset.nav === activeKey);
        });
    }
}

function getMenuTimeline() {
    if (!menuTimeline) {
        menuTimeline = gsap.timeline({paused: true})
            .to(label, {
                y: "-100%",
                opacity: 0,
                duration: 0.3,
                ease: "power2.out",
            })
            .to(path, {
                strokeDasharray: "20 300",
                strokeDashoffset: "-32.42",
                duration: 0.6,
                ease: "power2.inOut",
            }, "<")
            .to(icon, {
                rotate: -45,
                duration: 0.6,
                ease: "power2.inOut",
            }, "<")
            .to(menu, {
                y: "0%",
                duration: 0.6,
                ease: "power2.out",
            }, ">-=0.3");
    }

    return menuTimeline;
}

let instance;

export default () => {
    if (!instance) {
        instance = new Menu();
    }

    return instance;
}
